import React from 'react';
import { withTranslation } from 'react-i18next';

const ModalClose = ({ iconOnly, onClick, t }) => {
    return (
        <span onClick={onClick} className={'modal-close btn btn-close' + (iconOnly ? ' icon-only btn-close-large' : '')}>
            { iconOnly ? null : t('Close') } <i className="ion ion-close-round" />
        </span>
    );
}

export default withTranslation('common')(ModalClose)
